import React, { useEffect, useState } from "react";
import useMeasure from "react-use-measure";
import { classNames } from "@greeter/util";

import { useToggle } from "@greeter/matter";

import css from "./Accordion.module.scss";

export type AccordionProps = React.PropsWithChildren & {
  title: React.ReactNode;
};

export const Accordion: React.FC<AccordionProps> = ({ title, children, ...props }) => {
  const [collapsed, collapse] = useToggle(true);

  const [ref, bounds] = useMeasure();
  const [titleRef, titleBounds] = useMeasure();
  const [containerRef, containerBounds] = useMeasure();

  return (
    <div ref={ref} className={css.Accordion} {...props}>
      <div onClick={collapse} ref={titleRef} {...classNames(css.Title)}>
        {title}
      </div>
      <div
        ref={containerRef}
        {...classNames(css.Container, collapsed && css.Collapsed)}
        style={{
          maxHeight:
            (collapsed
              ? 0
              : containerBounds.height +
                bounds.top +
                bounds.bottom +
                titleBounds.height) + "px",
        }}
      >
        {children}
      </div>
    </div>
  );
};
